import React from 'react'
import { AppBar,Toolbar,IconButton,Badge,MenuItem,Menu,Typography } from '@material-ui/core'
import { ShoppingCart } from '@material-ui/icons'
import useStyle from './styles'
import {Link,useLocation} from 'react-router-dom'
const Navbar = ({totalItems}) => {
    const classes=useStyle();
    const location=useLocation();
    return (
        <>
            <AppBar position="fixed" className={classes.appBar} color="inherit">
                <Toolbar>
                    <Typography component={Link} to="/" variant="h6" className={classes.title} color="inherit">
                        <img src={'https://i.ibb.co/Qp1SXBw/commerce.png'} alt="e-commerce" height="25px" className={classes.image}/>
                        Electronic Market
                    </Typography>    
                    <div className={classes.grow}/>
                    {location.pathname==='/' && ( <div className={classes.button}>
                        <IconButton component={Link} to="/cart" aria-label="show cart" color="inherit">
                            <Badge badgeContent={totalItems} color="secondary">
                                <ShoppingCart/>
                            </Badge>
                        </IconButton>
                     </div>
           ) }
                        </Toolbar> 

            </AppBar>
        </>
    )
}

export default Navbar
